type FormatCurrencyOptions = {
  decimalPlaces?: number;
};

export const formatCurrency = (
  amount: number,
  options?: FormatCurrencyOptions
): string => {
  const decimalPlaces = options?.decimalPlaces ?? 2;

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: decimalPlaces,
    minimumFractionDigits: decimalPlaces,
  });

  return formatter.format(amount);
};
